export const gradeList = ['beginner', 'intermediate', 'advanced'];